import { Chip, Theme, withStyles, WithStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { IFilter, IFilters } from '../../models/states';
import FilterBar from '../FilterBar/FilterBar';
const styles = (theme: Theme) =>
  createStyles({
    root: {},
    filterWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    subheadingWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: '0.5rem'
    }
  });

class SubheadingBar extends React.Component<ISubheadingBarProps> {
  public render() {
    const { classes } = this.props;
    return (
      <div className={classes.subheadingWrapper}>
        <div className={classes.filterWrapper}>
          {this.props.totalItems !== this.props.filteredItems
            ? `Showing ${this.props.filteredItems} of ${this.props.totalItems} ${this.props.title}`
            : `All ${this.props.title}`}
          <div style={{ marginLeft: 5 }}>
            <FilterBar
              filters={this.props.filters}
              toggleFilter={this.props.toggleFilter}
            />
          </div>
        </div>
        {this.props.showLoading ? (
          <Typography variant={'body1'}>
            {this.props.loading
              ? 'Loading...'
              : `Last Refreshed : ${this.props.lastFetched}`}
          </Typography>
        ) : null}
      </div>
    );
  }
}
interface ISubheadingBarOwnProps extends WithStyles<typeof styles> {
  title: string;
  filteredItems: number;
  totalItems: number;
  filters: IFilters;
  toggleFilter: (filterName: string, filter: IFilter) => any;
  showLoading?: boolean;
  loading?: boolean;
  lastFetched?: string;
}

type ISubheadingBarProps = ISubheadingBarOwnProps;

export default withStyles(styles)(SubheadingBar);
